export const TILE_SIZE = 16;
export const MAP_SIZE = 64;
export const WORLD_SIZE_PX = MAP_SIZE * TILE_SIZE;
export const PATROL_SPEED_PX_PER_SECOND = 40;

export interface ZoneBounds {
  id: string;
  minTileX: number;
  maxTileX: number;
  minTileY: number;
  maxTileY: number;
}

export interface SignConfig {
  id: string;
  tileX: number;
  tileY: number;
  text: string;
}

export interface DoorConfig {
  id: string;
  tileX: number;
  tileY: number;
  targetTileX: number;
  targetTileY: number;
  targetZone: string;
  label: string;
}

export const WORLD_ZONES: ZoneBounds[] = [
  { id: 'village', minTileX: 1, maxTileX: 26, minTileY: 1, maxTileY: 30 },
  { id: 'forest', minTileX: 34, maxTileX: 62, minTileY: 1, maxTileY: 30 },
  { id: 'library', minTileX: 18, maxTileX: 46, minTileY: 34, maxTileY: 62 },
];

export const WORLD_SIGNS: SignConfig[] = [
  { id: 'sign-village', tileX: 10, tileY: 26, text: 'Village Square: talk to locals and share stories.' },
  { id: 'sign-forest', tileX: 46, tileY: 26, text: 'Forest Path: keep your lantern close and your pace steady.' },
  { id: 'sign-library', tileX: 31, tileY: 40, text: 'Library District: answers live on shelves and in questions.' },
];

export const WORLD_DOORS: DoorConfig[] = [
  {
    id: 'door-village-library',
    tileX: 28,
    tileY: 31,
    targetTileX: 31,
    targetTileY: 36,
    targetZone: 'library',
    label: 'To Library',
  },
  {
    id: 'door-library-village',
    tileX: 31,
    tileY: 33,
    targetTileX: 28,
    targetTileY: 29,
    targetZone: 'village',
    label: 'To Village',
  },
  {
    id: 'door-village-forest',
    tileX: 33,
    tileY: 16,
    targetTileX: 36,
    targetTileY: 16,
    targetZone: 'forest',
    label: 'To Forest',
  },
  {
    id: 'door-forest-village',
    tileX: 32,
    tileY: 16,
    targetTileX: 30,
    targetTileY: 16,
    targetZone: 'village',
    label: 'To Village',
  },
];

export const tileCenterToPixel = (tileCoordinate: number): number => tileCoordinate * TILE_SIZE + TILE_SIZE / 2;

export const getZoneByPixelPosition = (x: number, y: number): string => {
  const tileX = Math.floor(x / TILE_SIZE);
  const tileY = Math.floor(y / TILE_SIZE);

  const zone = WORLD_ZONES.find(
    (candidate) =>
      tileX >= candidate.minTileX &&
      tileX <= candidate.maxTileX &&
      tileY >= candidate.minTileY &&
      tileY <= candidate.maxTileY,
  );

  return zone?.id ?? 'wilderness';
};
